export const FOOD_ACCESS_DEFAULT_DEPARTMENT = "Antioquia";
export const FOOD_ACCESS_DEFAULT_CITY = "Medellín";
export const FOOD_ACCESS_ABURRA_REGION = "ABURRA_VALLEY";

export const FOOD_ACCESS_MUNICIPALITY_OPTIONS = [
  { value: "", label: "All Aburrá Valley", region: FOOD_ACCESS_ABURRA_REGION },
  { value: "Medellín", label: "Medellín", city: "Medellín" },
  { value: "Envigado", label: "Envigado", city: "Envigado" },
  { value: "Sabaneta", label: "Sabaneta", city: "Sabaneta" },
  { value: "Itagüí", label: "Itagüí", city: "Itagüí" },
  { value: "Bello", label: "Bello", city: "Bello" },
  { value: "La Estrella", label: "La Estrella", city: "La Estrella" },
  { value: "Caldas", label: "Caldas", city: "Caldas" },
  { value: "Copacabana", label: "Copacabana", city: "Copacabana" },
  { value: "Girardota", label: "Girardota", city: "Girardota" },
  { value: "Barbosa", label: "Barbosa", city: "Barbosa" },
];

export function buildFoodAccessGeographyParams(municipality = "") {
  const selected = FOOD_ACCESS_MUNICIPALITY_OPTIONS.find((option) => option.value === municipality);
  if (!selected || !selected.value) {
    return {
      department: FOOD_ACCESS_DEFAULT_DEPARTMENT,
      region: FOOD_ACCESS_ABURRA_REGION,
    };
  }
  return {
    department: FOOD_ACCESS_DEFAULT_DEPARTMENT,
    municipality: selected.value,
    city: selected.city || selected.value,
  };
}
